import request from "@/utils/request";
import md5 from 'js-md5'
import QS from 'qs'
import { sortASCII } from '@/utils'
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 查询月卡记录
export function queryMonthlyFee (data) {
  return request({
    url: GateWay + "/backstage/api/queryMonthlyFee",
    method: "post",
    data
  });
}

// 查询停车场配置
export function queryPark (data) {
  return request({
    url: GateWay + "/mainPlatform/queryPark",
    method: "post",
    data
  });
}